import { NextPage } from "next";

import CreditCheck from "scenes/CreditCheckNew";

const Index: NextPage = () => <CreditCheck />;

export default Index;
